import { API } from '../../../common/api/constants';

// Ищет по полному или частичному совпадению.
export const API_DADATA_BANK_POST = `${API}/utility/dadata/bank_data/name/`; // POST

//Универсальная добавление пользователя / заказчика // Для добавления заказчика более не используется
export const API_POST_PROFILE_CREATE_AND_FILL = `${API}/authorization/profile/create_and_fill`; // POST

//Добавление заказчика
export const ADD_CUSTOMER = `${API}/authorization/companies/{company_id}/customers`; // POST

//СПИСОК ЗАКАЗЧИКОВ
// export const GET_CUSTOMERS = `${API}/authorization/profile/{profile_id}/clients`;
export const GET_CUSTOMERS = `${API}/authorization/companies/{company_id}/customers`;

//СПИСОК ОТВЕТСТВЕННЫХ
export const GET_RESPONSIBLES = `${API}/authorization/representatives`;

//СПИСОК СТАТУСОВ
export const GET_STATUSES = `${API}/authorization/profiles/counts_by_statuses`;

//СПИСОК СТАТУСОВ
export const SEARCH_CUSTOMERS = `${API}/authorization/profile/clients`;

//СПИСОК ПОЗИЦИЙ
export const GET_POSITIONS = `${API}/authorization/representative/positions`;

//ПОЛУЧИТЬ ЗАКАЗЧИКА
// export const GET_CUSTOMER = `${API}/authorization/company/client/carrier_collaborated_with`;
export const GET_CUSTOMER = `${API}/authorization/customers/`;

//РЕДАКТИРОВАТЬ ЗАКАЗЧИКА
// export const EDIT_CUSTOMER = `${API}/authorization/profile/`;
export const EDIT_CUSTOMER = `${API}/authorization/customers/`;

//ЗАГРУЗИТЬ ФОТО ЗАКАЗЧИКА
export const UPLOAD_PHOTO_CUSTOMER = `${API}/utility/image/upload/company`;
